const React = require('react');
const MOBILE_TYPE = 'number';
const MOBILE_PATTERN = '[0-9]*';

const NON_MOBILE_PATTERN = '[0-9.,]*';
const NON_MOBILE_TYPE = 'text';
const { MobileDetection } = require('@reverbdotcom/discovery-ui');

class NumericInput extends React.Component {
  render() {
    const mobile = MobileDetection.isMobileBrowser();
    const type = mobile ? MOBILE_TYPE : NON_MOBILE_TYPE;
    const defaultPattern = mobile ? MOBILE_PATTERN : NON_MOBILE_PATTERN;
    const pattern = this.props.pattern || defaultPattern;
    const valueProps = {};
    if (this.props.defaultValue) {
      valueProps.defaultValue = this.props.defaultValue;
    } else if (this.props.value) {
      valueProps.value = this.props.value;
    }

    return (
      <input
        ref="input"
        type={type}
        pattern={pattern}
        className={this.props.className}
        required={this.props.required}
        placeholder={this.props.placeholder}
        disabled={this.props.disabled}
        name={this.props.name}
        {...valueProps}
        value={this.props.value}
        onChange={this.props.onChange}
      />
    );
  }
}

module.exports = NumericInput;



// WEBPACK FOOTER //
// ./javascripts/components/shared/numeric_input.jsx